module.exports = __webpack_public_path__ + "img/girl3.998944bb.jpg";